/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_I18nString } from './models_I18nString';
import type { models_QuestionOption } from './models_QuestionOption';
export type models_CreateQuestionRequest = {
    ask_during_checkin?: boolean;
    dependency_question?: number;
    dependency_values?: Array<string>;
    help_text?: models_I18nString;
    hidden?: boolean;
    identifier?: string;
    items?: Array<number>;
    options?: Array<models_QuestionOption>;
    position?: number;
    print_on_invoice?: boolean;
    question: models_I18nString;
    required?: boolean;
    show_during_checkin?: boolean;
    type: models_CreateQuestionRequest.type;
    valid_date_max?: string;
    valid_date_min?: string;
    valid_datetime_max?: string;
    valid_datetime_min?: string;
    valid_file_portrait?: boolean;
    valid_number_max?: number;
    valid_number_min?: number;
    valid_string_length_max?: number;
};
export namespace models_CreateQuestionRequest {
    export enum type {
        N = 'N',
        S = 'S',
        T = 'T',
        B = 'B',
        C = 'C',
        M = 'M',
        F = 'F',
        D = 'D',
        H = 'H',
        W = 'W',
        CC = 'CC',
        TEL = 'TEL',
    }
}

